import React, { useEffect } from 'react'

import { Outlet, useLocation } from 'react-router-dom'
import { Box, useDisclosure } from '@chakra-ui/react'

import { HeaderContext } from '@/context/Header'
import { Header } from '@/views/components/Header/Header'

import { ReferralModal } from './ReferralModal'

export const LayoutWithHeader: React.FC = () => {
  const [middleContent, setMiddleContent] =
    React.useState<React.ReactNode>(null)

  const referralModalDisclosure = useDisclosure()

  const location = useLocation()

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search)
    const referralModal = searchParams.get('referral-modal')

    if (referralModal === 'opened') {
      referralModalDisclosure.onOpen()
    }
  }, [location])

  return (
    <HeaderContext
      value={{ middleContent, setMiddleContent, referralModalDisclosure }}
    >
      <Box className="flex flex-col flex-grow mx-4 sm:mx-10 md:mx-20 lg:mx-10 xl:mx-20 my-10">
        <ReferralModal />
        <Header />
        <Outlet />
      </Box>
    </HeaderContext>
  )
}
